module.exports = __webpack_public_path__ + "img/elipses.545fbe3f.svg";